import { useTheme } from '@mui/material';
import { DetailItem, ItemListCard } from 'components/ItemListCard';
import { getTrans, TranslationKey } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { LANGUAGE_LEVEL_OPTIONS } from './constants';

export const LanguageSkillsDetailsList = ({
  values,
  onAddClick,
  onEditLanguageSkill,
  onDeleteLanguageSkill
}: {
  values: CVBuilderFormValues;
  onAddClick: () => void;
  onEditLanguageSkill?: (index: number) => void;
  onDeleteLanguageSkill?: (index: number) => void;
}) => {
  const theme = useTheme();

  const languageSkillsMissing = !values.languageSkills?.length;

  return (
    <ItemListCard
      isEmpty={languageSkillsMissing}
      showAddButton={true}
      addButtonLabel={getTrans(
        'cvBuilderPage.languageSkills.button.addLanguage.label'
      )}
      addButtonTestId="show-add-language-skill-form-button"
      onAddClick={onAddClick}
      emptyStateText={
        languageSkillsMissing
          ? getTrans('cvBuilderPage.languageSkills.button.addLanguage.body')
          : undefined
      }
      sx={{
        [theme.breakpoints.up('sm')]: {
          pb: 3
        },
        pb: 3
      }}
    >
      {values.languageSkills?.map((skill, index) => (
        <DetailItem
          onEditItem={() => onEditLanguageSkill?.(index)}
          onDeleteItem={() => onDeleteLanguageSkill?.(index)}
          key={index}
          title={skill.language ?? ''}
          details={[
            {
              value: (() => {
                const option = LANGUAGE_LEVEL_OPTIONS.find(
                  option => option.key === skill.level
                );
                return option
                  ? getTrans(option.value as TranslationKey)
                  : skill.level || '';
              })()
            }
          ]}
          sx={{ pb: 1 }}
        />
      ))}
    </ItemListCard>
  );
};
